<template>
  <div class="image-box" :class="shape">
    <el-image
      :src="avatarSrc"
      :lazy="true"
      class="feed-image"
      @click="handlePreview"
    >
      <div slot="error" class="image-slot">
        <img :src="defaultSrc" />
      </div>
    </el-image>
  </div>
</template>

<script>
import errorImg from "../../assets/image/cl_feed_img_error.png";
export default {
  name: "feed-image",
  props: {
    imgUrl: String,
    urlList: Array,
    shape: {
      type: String,
      default: "circle",
    },
  },
  computed: {
    avatarSrc: function () {
      let src = this.imgUrl;
      if (/^(https:|http:|\/\/)/.test(src)) {
        return src;
      } else {
        return this.defaultSrc;
      }
    },
    defaultSrc: function () {
      return errorImg;
    },
  },
  methods: {
    handlePreview() {
      this.$store.dispatch("pushPhotoList", this.urlList);
      this.$bus.$emit("photo-preview", {
        url: this.imgUrl,
      });
    },
  },
};
</script>

<style>
.image-box {
  width: 180px;
  height: 180px;
  margin: 5px 5px 0 0;
  /* display: flex;
    align-items: center; */
}

.feed-image {
  width: 100%;
  height: 100%;
}

.feed-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
